module.exports = __webpack_public_path__ + "static/media/samsung.b1de9929.png";